import _typeof from "@babel/runtime/helpers/typeof";

/**
 * @file objectEqual Judge whether two variables are equal.
 * @author yuzong(yuzong@tencent.com)
 */
import { equal } from './equal';
/**
 * Judge whether two variables are equal.
 *
 * @param first First variable.
 * @param second Second variable.
 * @param deep Deep compare.
 * @return Are the first and second equal.
 */

export function objectEqual(first, second) {
  var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (equal(first, second)) {
    return true;
  }

  if (_typeof(first) !== 'object' || _typeof(second) !== 'object') {
    return false;
  }

  if (first == null || second == null) {
    return false;
  }

  var firstKeys = Object.keys(first);
  var secondKeys = Object.keys(second);

  if (firstKeys.length !== secondKeys.length) {
    return false;
  }

  return firstKeys.every(function (item) {
    if (!Object.prototype.hasOwnProperty.call(second, item)) {
      return false;
    }

    var fv = first[item];
    var sv = second[item];

    if (deep) {
      return objectEqual(fv, sv, deep);
    }

    return equal(fv, sv);
  });
}